import { AuthenService } from '@/services/authen.service';
import { CommonService } from '@/services/Common.service';

export class InspectionService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();
  constructor() {
  }

  get headers() {
    return {
      'Content-Type': 'application/json',
      'auth': localStorage.getItem('token'),
    };
  }

  public getInspection(groupCd: string = ''
                     , shatenCd: string = ''
                     , kyotenCd: string = ''
                     , version: any = null
                     , sknInspectSeibiFeeId: any = null
                     , typeId: any = null
                     , categoryId: any = null) {
    let q = "";
    let param = '';
    if (groupCd != null) {
      param = "groupCd=" + groupCd;
    }
    if (shatenCd != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "shatenCd=" + shatenCd;
    }
    if (kyotenCd != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "kyotenCd=" + kyotenCd;
    }
    if (version != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "version=" + version;
    }
    if (sknInspectSeibiFeeId != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "sknInspectSeibiFeeId=" + sknInspectSeibiFeeId;
    }
    if (typeId != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "typeId=" + typeId;
    }
    if (categoryId != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "categoryId=" + categoryId;
    }
    if (param.length > 0) {
      q = '?' + param;
    }
    return this.commonService.get(`${this.baseAPI}/admin/inspection${q}`);
  }

  public getOsusumeInspection(groupCd: string = ''
                     , shatenCd: string = ''
                     , kyotenCd: string = ''
                     , version: any = null
                     , sknInspectSeibiFeeId: any = null
                     , categoryId: any = null) {
    let q = "";
    let param = '';
    if (groupCd != null) {
      param = "groupCd=" + groupCd;
    }
    if (shatenCd != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "shatenCd=" + shatenCd;
    }
    if (kyotenCd != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "kyotenCd=" + kyotenCd;
    }
    if (version != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "version=" + version;
    }
    if (sknInspectSeibiFeeId != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "sknInspectSeibiFeeId=" + sknInspectSeibiFeeId;
    }
    if (categoryId != null) {
      if (param.length > 0) {
        param += '&';
      }
      param += "categoryId=" + categoryId;
    }
    if (param.length > 0) {
      q = '?' + param;
    }
    return this.commonService.get(`${this.baseAPI}/admin/inspection-osusume${q}`);
  }
}
